export const PayoutMethods = {
    FREQUENCY: 'FREQUENCY',
    PAYOUT_THRESHOLD: 'PAYOUT_THRESHOLD'
};
